<div style="display: flex; justify-content: center; margin-top: 30px">
  <div style="width: 85%">
    <h2>Egreso de equipos</h2>

    <div
      *ngIf="!loading"
      style="display: flex; justify-content: center; margin-top: 1rem"
    >
      <mat-form-field appearance="outline" class="divInputSearch">
        <mat-label>Filtrar</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Filtrar Búsqueda"
        />
      </mat-form-field>
    </div>

    <div *ngIf="!loading" style="display: flex; justify-content: space-between">
      <div
        class="divButtons"
        style="justify-content: flex-start; margin-bottom: 1rem"
      >
        <mat-form-field appearance="fill" class="buttonFilter">
          <mat-label>FILE</mat-label>
          <mat-select
            [(value)]="selectFile"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="{{ null }}">No seleccionar</mat-option>
            <mat-option *ngFor="let file of arrayFiles" value="{{ file }}">{{
              file
            }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="buttonFilter">
          <mat-label>PRODUCTO</mat-label>
          <mat-select
            [(value)]="selectProducto"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="{{ null }}">No seleccionar</mat-option>
            <mat-option
              *ngFor="let producto of arrayProductos"
              value="{{ producto }}"
              >{{ producto }}</mat-option
            >
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="buttonFilterFecha">
          <mat-label>FECHA OPERACIÓN</mat-label>

          <mat-datepicker-toggle
            matSuffix
            [for]="rangePicker"
          ></mat-datepicker-toggle>

          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Inicio" [(ngModel)]="startDate" />
            <input matEndDate placeholder="Fin" [(ngModel)]="endDate" />
          </mat-date-range-input>

          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button
                style="background-color: rgb(184, 69, 18); color: white"
                mat-raised-button
                (click)="applyFilterSelect()"
                matDateRangePickerApply
              >
                Filtrar
              </button>

              <button
                mat-button
                matDateRangePickerCancel
                (click)="cleanDateSelected()"
              >
                Limpiar
              </button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </div>

      <!--  <button mat-raised-button class="buttonPrimary" style="height: 50%;width: 13rem;" (click)="generarOrdenSalida()">Generar Orden de Salida</button> -->
    </div>

    <div *ngIf="loading" class="spinner">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>

    <div *ngIf="!loading" class="mat-elevation-z8 overflow">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="check">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox [checked]="row.checked" (change)="updateCheck(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="fileNumber">
          <th mat-header-cell *matHeaderCellDef>FILE</th>
          <td mat-cell *matCellDef="let element">{{ element.fileNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="productName">
          <th mat-header-cell *matHeaderCellDef>PRODUCTO</th>
          <td mat-cell *matCellDef="let element">{{ element.productName }}</td>
        </ng-container>

        <ng-container matColumnDef="fechaOperacion">
          <th mat-header-cell *matHeaderCellDef>FECHA OPERACIÓN</th>
          <td mat-cell *matCellDef="let element">
            {{ element.fechaInicio + " - " + element.fechaFin }}
          </td>
        </ng-container>

        <!--         <ng-container matColumnDef="cantPax">
          <th mat-header-cell *matHeaderCellDef>PAX</th>
          <td mat-cell *matCellDef="let element">{{ element.cantPax }}</td>
        </ng-container> -->

        <ng-container matColumnDef="cantPax">
          <th mat-header-cell *matHeaderCellDef>PAX</th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button (click)="openDialogPax(element)">
              <mat-icon
                matBadge="{{ element.cantPax }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="editar">
          <th mat-header-cell *matHeaderCellDef>
            ASIGNAR CLASIFICACIÓN EQUIPOS
          </th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              color="primary"
              (click)="openDialogAsignarTipoEquipo(element)"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="detalle">
          <th mat-header-cell *matHeaderCellDef> ASIGNAR EQUIPOS </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button color="primary" (click)="navigateToDetalle(element)" routerLinkActive="active">

              <mat-icon>open_in_new</mat-icon>
            </button>
          </td>
        </ng-container> -->

        <ng-container matColumnDef="generarOS">
          <th mat-header-cell *matHeaderCellDef>GENERAR ORDEN DE SALIDA</th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              color="primary"
              (click)="generarOrdenSalida(element)"
            >
              <mat-icon>post_add</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="ordenSalida">
          <th mat-header-cell *matHeaderCellDef>ORDEN DE SALIDA</th>
          <td mat-cell *matCellDef="let element">
            <button
              *ngIf="element.numberOrdenSalida"
              mat-icon-button
              color="primary"
              (click)="openDialogVerPdf(element)"
            >
              <mat-icon>picture_as_pdf</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div [hidden]="loading">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</div>
